__turbopack_context__.v({
  "hairline": "SiteNav-module-scss-module__5TlSfG__hairline",
  "landing": "SiteNav-module-scss-module__5TlSfG__landing",
  "panelIn": "SiteNav-module-scss-module__5TlSfG__panelIn",
  "premiumTrigger": "SiteNav-module-scss-module__5TlSfG__premiumTrigger",
  "root": "SiteNav-module-scss-module__5TlSfG__root",
});
